import { render, staticRenderFns } from "./ActivityDayOathPane.vue?vue&type=template&id=5b360979&scoped=true"
import script from "./ActivityDayOathPane.vue?vue&type=script&lang=js"
export * from "./ActivityDayOathPane.vue?vue&type=script&lang=js"
import style0 from "./ActivityDayOathPane.vue?vue&type=style&index=0&id=5b360979&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b360979",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b360979')) {
      api.createRecord('5b360979', component.options)
    } else {
      api.reload('5b360979', component.options)
    }
    module.hot.accept("./ActivityDayOathPane.vue?vue&type=template&id=5b360979&scoped=true", function () {
      api.rerender('5b360979', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/AppPage/ HundredDayOath/compoents/ActivityDayOathPane.vue"
export default component.exports